module.exports = __webpack_public_path__ + "assets/maison-campagne-big.edd9da2b.svg";